import React from 'react'


export const PurchaseSuccessPage = () => {
    return (
        <div className="flex">
            <div className="flex-1 p-4">
                <h1 className="text-4xl font-bold">PURCHASE SUCCESS</h1>
            </div>
        </div>
      )
    }

export default PurchaseSuccessPage